import React from 'react'
import { connect } from 'react-redux'
import Container from 'muicss/lib/react/container'
import Row from 'muicss/lib/react/row'
import Col from 'muicss/lib/react/col'
import Panel from 'muicss/lib/react/panel'
import MissionIndex from './MissionIndex'
import PreMissionShow from './PreMissionShow'
import Avatar from '../BadgeHeroesComponents/Avatar'
import { resetSelectedMission } from '../../actions'


const styles = {
  header:{
    display: 'inline-block',
    marginBottom:'20px',
  },
  root: {
    backgroundColor: '#e6e6e6',
    minHeight: 'calc(100vh - 80px)',
    paddingTop: '30px',
  },
  avatarContainer: {
    textAlign: 'center',
    position: 'relative',
    display: 'inline-block',
    margin: 'auto',
    width: '100px',
    height: '50px',
  },
  empty:{
    textAlign: 'center',
    minHeight: '300px',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
  }
}


class CampaignShow extends React.Component {

  componentDidMount() {
    this.props.resetSelectedMission()
  }

  _chunk(array) {
    let i
    let j
    const temparray = []
    const chunk = 3
    for (i = 0, j = array.length; i < j; i += chunk) {
      temparray.push(array.slice(i, i + chunk))
    }
    return temparray
  }

  render() {
    const { name, selectedMission, image_url } = this.props.campaign
    const { missions } = this.props
    const render_missions = this._chunk(missions.map(mission =>
      <Col lg="4" md="4" xs="12" sm="12" key={mission.id} >
        <MissionIndex
          {...mission}
        />
      </Col>,
    )).map((element, index) =>
      <Row key={index}>
        {element}
      </Row>,
    )
    return (
      <Container fluid style={styles.root}>
        <Row>
          <Col xs="12" md="8" lg="9" xs-offset="0" md-offset="0">
            <Panel>
              <div style={styles.avatarContainer}>
                <Avatar image_url={image_url} size={70} />
              </div>
              <div style={styles.header}>
                <h1>
                  {name}
                </h1>
              </div>
              {missions.length > 0 ?
                render_missions :
                <Col xs="12" style={styles.empty}><h1>¡No hay misiones disponibles!</h1></Col>
              }
            </Panel>
          </Col>
          <Col xs="12" md="4" lg="3" xs-offset="0" md-offset="0">
            <PreMissionShow selectedMission={selectedMission} />
          </Col>
        </Row>
      </Container>
    )
  }
}


const mapStateToProps = state => ({
  campaign: state.campaigns.selectedCampaign,
  selectedMission: state.missions.selectedMission,
  missions: state.missions.missions,

})

const mapDispatchToProps = dispatch => ({
  resetSelectedMission: () => {
    dispatch(resetSelectedMission())
  },
})


export default connect(mapStateToProps, mapDispatchToProps)(CampaignShow)



// WEBPACK FOOTER //
// ./src/components/CampaignShow/index.jsx